exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-adea0f08] .v-input .v-input__slot{border-radius:33px!important}[data-v-adea0f08] .v-menu__content{border-radius:23px}", ""]);

// exports
